import * as types from "./types";

export default {
  [types.MUTATE_LOADING]: (state, isLoading) => {
    state.isLoading = isLoading;
  }
};
